<template lang="html">
</template>

<script>
import { EventBus } from "@/bus";
import { forgetDeviceKey } from "@/deviceKey";

export default {
    created() {
        // The logout request itself still needs the device key, so the local
        // copy is dropped only once the server has been told to kill the session.
        this.$services.Logout().save().then(resp => {
            forgetDeviceKey()
            EventBus.emit('context:updated', {id: null})
            window.location.href = '/'
        })
    }
}
</script>
